import { Episode } from '@intigral/shared';
import { convertHttpToHttps } from '@intigral/utils';
import { Link } from 'react-router-dom';
import h from '../../../helpers/common';
import f2 from '../../../helpers/formatter2';
import url from '../../../helpers/url';
import { __ } from '../../../translations';
import { useConfiguration } from '../../../hooks/useConfiguration';
import useLanguage from '../../../hooks/useLanguage';
import { iEpisodeItemProps } from '../types/iSeasons';
import { useEpoisodeItem } from '../hooks/useEpisodeItem';
import user from '../../../helpers/user';
import { getCountry } from '../../../helpers/common';
import { useGetBookMarksQuery } from '@intigral/domain/lib/presentation/hooks/useGetBookMarksQuery';
import { isGuestUser } from '../../../config/guestMode';

export const EpisodesItem: React.FC<iEpisodeItemProps> = ({ details }) => {
    const { data: newConfig } = useConfiguration();
    const language = useLanguage();
    const duration = f2.convertSecondsToMinutes(details.duration);
    const { isLocked, isLockedFunc, canPlayContent, showParentalPopupMessage } = useEpoisodeItem(details);
    const currentUser = user.getUserInfo();
    const isGuest = isGuestUser(currentUser);
    const profileGuid = user.getProfile()?.profileGuid;
    const { data: bookmarks } = useGetBookMarksQuery({
        apiKey: user.getAPIKey(),
        profileGuid: isGuest ? undefined : profileGuid,
        authToken: user.getUserToken(),
        identityToken: user.getIdentityToken(),
        country: getCountry(),
        device: h.getDevice(),
        programType: 'all',
    });
    const bookmark = bookmarks?.find((bmk) => bmk?.paId === details?.Id);

    const bookmarkedItem = { ...bookmark, ...details }; // Merging episode details into the bookmark;
    return (
        <Episode
            image={h.getImagizerUrl(
                convertHttpToHttps(details['image_landscape']),
                newConfig?.imagizer?.components_images.SEASON_EPISODES_ITEM
            )}
            number={`S${details.tvSeasonNumber}.E${details.tvSeasonEpisodeNumber}`}
            title={language === 'ar' ? details.text : details.textEn}
            duration={duration ? `${duration} ${__('min')}` : undefined}
            progress={
                bookmarkedItem?.timecode && bookmarkedItem?.duration
                    ? `${(+bookmarkedItem.timecode / +bookmarkedItem.duration) * 100}%`
                    : undefined
            }
            description={language === 'ar' ? details.description : details.descriptionEn}
            link={{
                linkComponent: Link,
                transformLinkProps: (props) => ({ to: props.href }),
                href: url.route('play', {
                    id: btoa(details.Id),
                    guid: btoa(details.guid),
                    season: details.tvSeasonNumber ? details.tvSeasonNumber : details.seasonNumber,
                }),
            }}
            isLocked={isLocked}
            isLockedFunc={isLockedFunc}
            canPlayContent={canPlayContent}
            showParentalPopupMessage={showParentalPopupMessage}
        />
    );
};
